import { createRootRouteWithContext, Navigate, Outlet, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { Toaster } from "@/components/ui";
import { useMeInfo } from "@/features/auth/hooks/use-me-query";
import { type Auth, useAuthStore } from "@/features/auth/store/useAuthStore";

type RouterContext = {
  auth: Auth;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  const isLogin = useAuthStore.use.isLogin();
  const setMe = useAuthStore.use.setMe();
  const { data: me, isSuccess } = useMeInfo();

  const router = useRouter();

  useEffect(() => {
    if (!isLogin || !isSuccess || !me) return;
    setMe(me);
    router.invalidate();
  }, [me, isSuccess, isLogin, router, setMe]);

  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}

/**
 *  當輸入未知的頁面時，直接重新導向到首頁
 */
function NotFoundPage() {
  return <Navigate to="/" />;
}
